/**
 * @internal
 */
export function redirectToDirectory({ fullRoute, response, }) {
    const { url } = fullRoute;
    // send redirect response
    response.statusCode = 301;
    response.setHeader('Content-Type', 'text/html; charset=UTF-8');
    response.setHeader('Content-Security-Policy', "default-src 'none'");
    response.setHeader('X-Content-Type-Options', 'nosniff');
    response.setHeader('Location', `${url.pathname}/${url.search}`);
    response.end();
}
//# sourceMappingURL=redirect-to-directory.impl.js.map